import {
  blackColor,
  whiteColor,
  hexToRgb,
} from 'material-dashboard-assets/jss/material-dashboard-react.js';

const cardStyle = {
  card: {
    border: '1px solid lightgray',
    marginBottom: '30px',
    marginTop: '30px',
    borderRadius: '6px',
    color: 'rgba(' + hexToRgb(blackColor) + ', 0.87)',
    background: whiteColor,
    width: '100%',
    minHeight: 150,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    minWidth: '270px',
    wordWrap: 'break-word',
    fontSize: '.875rem',
  },
  cardPlain: {
    background: 'transparent',
    boxShadow: 'none',
  },
  cardProfile: {
    marginTop: '30px',
    textAlign: 'center',
  },
  cardChart: {
    '& p': {
      marginTop: '0px',
      paddingTop: '0px',
    },
  },
};

export default cardStyle;
